import { render, staticRenderFns } from "./deposit-type-tab.vue?vue&type=template&id=24c1884e&"
import script from "./deposit-type-tab.vue?vue&type=script&lang=js&"
export * from "./deposit-type-tab.vue?vue&type=script&lang=js&"
import style0 from "./deposit-type-tab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "deposit-type-tab.vue"
export default component.exports